export const budgetFilterDefaults = {
    totalMax: 2000000,
    totalMin: 100000,
    totalValue: 550000,
    monthlyMax: 20000,
    monthlyMin: 500,
    monthlyValue: 2000
};
